import { AssetFile, AssetProvider, Configuration } from "threngine";

export class FileLoadProgress {

    constructor (private assetProvider:AssetProvider) {}

    getProgressForConfig = (config:Configuration, callback:(p:number)=>void) => {
        const assetIds = [];

        for (const vset of config.default_state.visibility_sets) {
            const vId = vset.visibility_group_id;
            if (vId) {
                for (const assetId of this.getAssetIdsForVisibilityGroup(config, vId)) {
                    if (assetIds.indexOf(assetId) == -1) {
                        assetIds.push(assetId);
                    }
                }
            }
        }

        for (const grouping of config.default_state.grouping_visible) {
            const gId = grouping.id;
            if (grouping.visible) {
                for (const assetId of this.getAssetIdsForGrouping(config, gId)) {
                    if (assetIds.indexOf(assetId) == -1) {
                        assetIds.push(assetId);
                    }
                }
            }
        }

        // TODO: deduplicate this
        const filesToLoad = this.getFilesToLoad(assetIds);
        const filesLoaded:AssetFile[] = [];

        console.log(filesToLoad)

        const onFileLoad = (f:AssetFile) => {
            const found = filesToLoad.find(l => f.id===l.id && f.fileName===l.fileName);
            if (!found) return Promise.resolve();

            filesLoaded.push(found);

            const p = filesLoaded.length/filesToLoad.length;
            
            if (p<1) {
                callback(p);
            } else {
                callback(1);
                this.assetProvider.onFileLoaded.unsubsribe(onFileLoad);
            }

            return Promise.resolve();
        }

        this.assetProvider.onFileLoaded.subscribe(onFileLoad);
    }


    getProgressForVisibilityGroup = (config:Configuration, vId:string, callback:(p:number)=>void) => {
        const assetIds = this.getAssetIdsForVisibilityGroup(config, vId);
        
        const filesToLoad = this.getFilesToLoad(assetIds);
        const filesLoaded:AssetFile[] = [];

        console.log(filesToLoad)

        const onFileLoad = (f:AssetFile) => {
            const found = filesToLoad.find(l => f.id===l.id && f.fileName===l.fileName);
            if (!found) return Promise.resolve();

            filesLoaded.push(found);

            const p = filesLoaded.length/filesToLoad.length;
            
            if (p<1) {
                callback(p);
            } else {
                callback(1);
                this.assetProvider.onFileLoaded.unsubsribe(onFileLoad);
            }

            return Promise.resolve();
        }

        this.assetProvider.onFileLoaded.subscribe(onFileLoad);
    }

    private getAssetIdsForVisibilityGroup = (config:Configuration, vId:string) => {
        const vgroup = config.visibility_groups.find(v => v.id===vId);
        
        if (!vgroup) {
            console.warn("Could not find visibility group with id", vId);
            return [];
        }

        const assetIds:string[] = [];

        vgroup.grouping_ids.forEach(gId => {
            for (const assetId of this.getAssetIdsForGrouping(config, gId)) {
                if (assetIds.indexOf(assetId) == -1) {
                    assetIds.push(assetId);
                }
            }
        })

        return assetIds;
    }

    private getAssetIdsForGrouping = (config:Configuration, gId:string) => {
        const assetIds:string[] = [];

        const grouping = config.groupings.find(g => g.id===gId);
        if (!grouping) throw new Error(`No Grouping found with id ${gId} in config ${config}`)
            
        if (assetIds.indexOf(grouping.geometry_id)<0) {
            assetIds.push(grouping.geometry_id);
        }

        const defMat = config.default_state.grouping_material.find(g => g.id===gId);
        if (defMat && assetIds.indexOf(defMat.material_id)<0) {
            assetIds.push(defMat.material_id);
        }

        config.material_groups
        .filter(mg => mg.grouping_ids.indexOf(gId)>=0)
        .forEach(mg => {
            const defMatGroup = config.default_state.material_groups.find(dmg => dmg.id===mg.id);
            if (defMatGroup && defMatGroup.material_id && assetIds.indexOf(defMatGroup.material_id)<0) {
                assetIds.push(defMatGroup.material_id);
            }
        });

        return assetIds;
    }

    private getFilesToLoad = (assetIds:string[]) => {
        const assets = this.assetProvider.getAssets();
        const fileData:{id:string, fileName:string}[] = [];

        const extractFileData = (assetId:string) => {
            const asset = assets.find(a => a.id===assetId);
            if (!asset) throw Error(`No asset found with id ${assetId}`);
            
            // Skip preview images as they are not required
            const filtered = asset.files.filter(f => f!=="preview.png");

            filtered.forEach(f => {
                if (fileData.find(d => d.id===assetId && d.fileName===f)===undefined) {
                    fileData.push({id: assetId, fileName: f});
                }
            });

            if (asset.assetList) {
                asset.assetList.forEach(entry => extractFileData(entry.id));
            }
        }

        assetIds.forEach(extractFileData);

        return fileData;
    }
}